/* =========================================================
   UpperEast Jewels — PDP JavaScript (Horizon-compatible)
   Horizon ha già `sticky-add-to-cart` built-in, quindi qui solo:
   - Smooth scroll per anchor links
   - Future hooks AR/quiz/wishlist
   ========================================================= */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initSmoothScroll();
  });

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href').slice(1);
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }
})();
